module.exports = __webpack_public_path__ + "static/media/warning-symbol.9c987bf2.png";